/**
 * 모두의 차고 인앱 — 내 차 오너 리뷰 조회/별점 저장 (클라이언트 전용)
 *
 * BFF 프록시(/api/modoocar/review)를 경유해 social-v2
 * review-management-controller(getMacarReview/updateReview)를 호출한다.
 * 인앱 웹뷰의 remember-me 쿠키(사용자 세션)가 프록시에서 전달된다. (Figma 9064:32674)
 */
import { getApiPath } from '@/app/(makers)/_utils'
import { clientHttp } from '@/shared/api/client'

/** getMacarReview Feed 응답 — 팝업 노출 판단에 쓰는 필드만 정의 */
interface IMyCarReviewFeed {
  serverId?: number
  /** 리뷰 본문 제목 — 비어 있으면 별점만 남긴 상태 */
  title?: string
  /** 별점 (1~5) */
  score?: number
}

interface IMyCarReviewResponse {
  success: boolean
  /** 내 차 리뷰 — 없으면 null (단건 또는 목록 응답 방어) */
  data: IMyCarReviewFeed | IMyCarReviewFeed[] | null
}

/** 내 차 리뷰 상태 — 별점/리뷰 팝업 노출 판단용 */
export interface IMyCarReviewStatus {
  /** 리뷰(별점 포함) 존재 여부 — false면 별점 팝업 노출 */
  hasReview: boolean
  /** 리뷰 글(title) 존재 여부 — false면 전체보기 클릭 시 리뷰 팝업 노출 */
  hasReviewText: boolean
}

const pickFirstReview = (
  data: IMyCarReviewResponse['data']
): IMyCarReviewFeed | null => {
  if (!data) return null
  if (Array.isArray(data)) return data[0] ?? null
  return data
}

export const getMyCarReviewStatus = async (
  macarServerId: string
): Promise<IMyCarReviewStatus> => {
  const reviewResponse: IMyCarReviewResponse = await clientHttp.get(
    getApiPath(`/api/modoocar/review?macarServerId=${macarServerId}`)
  )
  const review = pickFirstReview(reviewResponse.data)
  return {
    hasReview: Boolean(review),
    hasReviewText: Boolean(review?.title?.trim()),
  }
}

export const updateMyCarReviewScore = async ({
  macarServerId,
  score,
}: {
  macarServerId: string
  score: number
}): Promise<void> => {
  await clientHttp.patch(
    getApiPath(`/api/modoocar/review?macarServerId=${macarServerId}`),
    { body: { score } }
  )
}
